<iframe title="PBI SLA Transilien" class="power-bi-iframe"
    [src]="powerBiUrl"
    frameborder="0" allowFullScreen="true"></iframe>
